import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent } from 'services/analytics';

// https://data-portal.internal.atlassian.com/analytics/registry/71740
const trackCameraButtonClick = (isPersonalView: boolean) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'headerCameraButton',
    isPersonalView,
    source: SCREEN_NAME.PROFILE,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71751
const trackEditProfileButtonClick = (isPersonalView: boolean) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'editProfileButton',
    isPersonalView,
    source: SCREEN_NAME.PROFILE,
  });
};

export { trackCameraButtonClick, trackEditProfileButtonClick };
